import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Chat from './Chat';
import ChatPage from './ChatPage';

function HomePage() {
  return (
    <div className="App">
      <header className="hero-section">
        <div className="hero-content">
          <h1 className="school-title">Lý do chọn trường Einstein</h1>
          <div className="underline"></div>
        </div>
      </header>
      
      <main className="main-content">
        <div className="content-wrapper">
          <div className="text-sections">
            <section className="info-section education-method">
              <h2>Giáo dục tính cách bằng hành động</h2>
              <p>
                Nhà trường nhận mạnh sự phát triển nhân cách bằng cách thấm nhuần các giá trị cốt lõi như kiến tạo hòa bình, trách nhiệm, tôn trọng, kiên trì, quan tâm, lạc quan, chính trực, can đảm, hợp tác và biết ơn ở học sinh, hướng dẫn hành vi và hành động của các em cả trong và ngoài cộng đồng trường học.
              </p>
            </section>

            <section className="info-section skills-21st">
              <h2>Kỹ năng thế kỷ 21 và Công dân toàn cầu</h2>
              <p>
                Chương trình này được đánh riêng để trang bị cho học sinh các kỹ năng của thế kỷ 21 thông qua chương trình giảng dạy tiếng Anh nhấn mạnh vào giao tiếp hiệu quả, tư duy phản biện, hợp tác và thích ứng với bối cảnh toàn cầu đang thay đổi nhanh chóng. Nó cũng tập trung vào việc phát triển khả năng sáng tạo, giải quyết vấn đề, hiểu biết về kỹ thuật số và lĩnh hội văn hóa toàn cầu.
              </p>
            </section>

            <section className="info-section green-school">
              <h2>Trường học hạnh phúc</h2>
              <p>
                Chúng tôi điều hành dự án Trường học Xanh, nhằm mục đích nâng cao nhận thức về môi trường của học sinh thông qua trải nghiệm thực tế và giáo dục về tính bền vững, bảo tồn và trách nhiệm với môi trường. Mục tiêu là tạo ra một thế hệ những cá nhân có ý thức về môi trường, những người đóng góp cho một tương lai bền vững.
              </p>
            </section>
          </div>
          
          <div className="image-section">
            <div className="student-image">
              <div className="image-placeholder">
                <p>Học sinh Einstein đang học tập</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Chat />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/chat" element={<ChatPage />} />
      </Routes>
    </Router>
  );
}

export default App;
